const ACTIVE_SHIFT_STATES = new Set([
  'ready_to_open',
  'active',
  'opening',
  'wake_up_pending',
  'wake_up_confirmed',
]);

const milliseconds = value => {
  if (typeof value?.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  const parsed = typeof value === 'string' ? Date.parse(value) : Number.NaN;
  return Number.isFinite(parsed) ? parsed : 0;
};

export function selectEmployeeShift(shifts) {
  return [...shifts].sort((left, right) => {
    const activeDifference = Number(ACTIVE_SHIFT_STATES.has(right.status)) - Number(ACTIVE_SHIFT_STATES.has(left.status));
    if (activeDifference) return activeDifference;
    return milliseconds(right.plannedStartAt) - milliseconds(left.plannedStartAt);
  })[0] || null;
}

const PHASE_RANK = { opening: 0, active: 1, closing: 2 };

export function tasksForShift(tasks, shiftId) {
  if (!shiftId) return [];
  return tasks
    .filter(task => task.shiftId === shiftId)
    .sort((left, right) =>
      (left.order || 0) - (right.order || 0)
      || (PHASE_RANK[left.phase] ?? 9) - (PHASE_RANK[right.phase] ?? 9)
      || milliseconds(left.availableAt) - milliseconds(right.availableAt));
}

export function readableMobileError(error) {
  if (error?.code === 'NETWORK_UNAVAILABLE') return 'Нет соединения. Проверьте сеть и повторите попытку.';
  if (error?.code === 'REQUEST_TIMEOUT') return 'Сервер не ответил вовремя. Команду можно безопасно повторить.';
  if (error?.retryable) return 'Временная ошибка сервера. Повторите попытку.';
  // Prefer the server's own message when it's a plain sentence (Cyrillic /
  // spaces) rather than a bare CODE.
  const msg = error?.serverMessage;
  if (typeof msg === 'string' && /[а-яё ]/i.test(msg) && !/^[A-Z_]+$/.test(msg)) return msg;
  return error?.code ? `Ошибка: ${error.code}` : 'Не удалось обновить данные.';
}
